import { columns } from '../utils/constant';

export default function ClaimHeader() {
    return (
        <div className='hidden xl:flex flex-row justify-between bg-[#121212] w-full px-[50px] 2xl:px-[180px] pt-[40px] pb-[16px]'>
            {columns.map((col, index) => (
                <p
                    key={col.key}
                    className={`text-[#86888C] text-[16px] font-Inter-Regular basis-2/12 uppercase ${index === 5 ? 'text-center' : ''}`}
                >
                    {col.title}
                </p>
            ))}
        </div>
    )
}
